import React from 'react';
import { ApIcon, colors } from '@alixpartners/ui-components';

import {
  Wrapper,
  Header,
  HeaderLabel,
  Content,
  IconWrapper,
  ContentWrapper,
} from './Collapsible.styles';

interface IProps {
  header: (() => React.ReactNode) | string;
  /** Prop to control collapsible (example collapse all items in a group) */
  isOpen?: boolean;
  onClick?(): void;
  headerClassName?: string;
  wrapperClassName?: string;
  children: React.ReactNode;
}

interface IState {
  isCollapsed: boolean;
}

export class Collapsible extends React.Component<IProps, IState> {
  static defaultProps = {
    isOpen: false,
  };

  state = {
    isCollapsed: !this.props.isOpen,
  };

  componentDidUpdate(prevProps: IProps) {
    const { isOpen } = this.props;

    if (isOpen !== prevProps.isOpen) {
      this.setState({ isCollapsed: !isOpen });
    }
  }

  toggle = () => this.setState({ isCollapsed: !this.state.isCollapsed });

  render() {
    const {
      header,
      headerClassName,
      children,
      onClick,
      wrapperClassName,
    } = this.props;
    const { isCollapsed } = this.state;
    const toggleHandler = onClick ? onClick : this.toggle;

    return (
      <Wrapper className={wrapperClassName}>
        <Header className={headerClassName} onClick={toggleHandler}>
          <IconWrapper isCollapsed={isCollapsed} onClick={toggleHandler}>
            <ApIcon
              iconName="baseline_keyboard_arrow_down"
              iconColor={colors.grey4}
              iconSize={28}
            />
          </IconWrapper>

          {typeof header === 'string' ? (
            <HeaderLabel>{header}</HeaderLabel>
          ) : (
            header()
          )}
        </Header>

        <ContentWrapper isCollapsed={isCollapsed}>
          <Content>{children}</Content>
        </ContentWrapper>
      </Wrapper>
    );
  }
}

export default Collapsible;
